import {Service} from '@s-ui/domain'

/**
 * @class
 * @implements SendEmailValidationService
 */

export default class SendEmailValidationService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPNotificationsRepository} deps.httpRepository
   * @param {Repository} deps.getCurrentUserService
   */
  constructor({httpRepository, getCurrentUserService}) {
    super()
    this._httpRepository = httpRepository
    this._getCurrentUserService = getCurrentUserService
  }

  /**
   * @return {Promise}
   */
  async execute() {
    const userEntity = await this._getCurrentUserService.execute()
    const httpRepositoryInstance = this._httpRepository(userEntity)

    return httpRepositoryInstance.sendEmailValidation()
  }
}
